export class SetSeenAction {
  static readonly type = '[Seen] Set Seen';

  constructor(public payload: number) { }
}